import { z } from 'zod';

export const loginFormSchema = z.object({
  email: z.string().email('Por favor, insira um e-mail válido'),
  password: z.string().min(6, 'A senha deve ter pelo menos 6 caracteres'),
});

export const signupFormSchema = z.object({
  name: z.string().min(1, 'Nome é obrigatório'),
  email: z.string().email('Por favor, insira um e-mail válido'),
  password: z
    .string()
    .min(8, 'A senha deve ter pelo menos 8 caracteres')
    .regex(/[A-Z]/, 'A senha deve conter pelo menos uma letra maiúscula')
    .regex(/[a-z]/, 'A senha deve conter pelo menos uma letra minúscula')
    .regex(/[0-9]/, 'A senha deve conter pelo menos um número')
    .regex(/[!@#$%^&*(),.?":{}|<>]/, 'A senha deve conter pelo menos um caractere especial'),
});

export const forgotPasswordFormSchema = z.object({
  email: z.string().email('Por favor, insira um e-mail válido'),
});

export const categoryFormSchema = z.object({
  name: z.string().min(1, 'Nome da categoria é obrigatório').max(50, 'Nome muito longo'),
  type: z.enum(['income', 'expense'], { required_error: 'Selecione um tipo' }),
});

export const transactionFormSchema = z.object({
  amount: z.string().min(1, 'Valor é obrigatório').refine(
    (val) => !isNaN(parseFloat(val)) && parseFloat(val) > 0,
    'O valor deve ser maior que 0'
  ),
  category_id: z.string().min(1, 'Selecione uma categoria'),
  date: z.string().min(1, 'Selecione uma data'),
  description: z.string().min(1, 'Descrição é obrigatória').max(200, 'Descrição muito longa'),
  type: z.enum(['income', 'expense'], { required_error: 'Selecione um tipo' }),
});

export type LoginFormData = z.infer<typeof loginFormSchema>;
export type SignupFormData = z.infer<typeof signupFormSchema>;
export type ForgotPasswordFormData = z.infer<typeof forgotPasswordFormSchema>;
export type CategoryFormData = z.infer<typeof categoryFormSchema>;
export type TransactionFormData = z.infer<typeof transactionFormSchema>;
